import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

import { CBMError, VildVersion } from 'app/models';
import { VildVersionService } from 'app/services';

@Component({
  selector: 'app-dialog-vild-approve',
  templateUrl: './dialog-vild-approve.component.html',
  styleUrls: ['./dialog-vild-approve.component.scss']
})
export class DialogVildApproveComponent {
  @ViewChild('confirmApproveVildVersionDialog') confirmApproveVildVersionDialog: ModalDirective;

  @Input() vildVersion: VildVersion;
  @Output() onConfirm = new EventEmitter<boolean>();

  private readonly modalTimeout = 2000;

  public isApprovingVild = false;
  public vildVersionIsSuccessfullyApproved = false;
  public approveVildErrorMessages: CBMError[] = [];

  constructor(public readonly vildVersionService: VildVersionService) {}

  public show(): void {
    this.confirmApproveVildVersionDialog.show();
  }

  public stopApproveVildVersion(): void {
    this.vildVersion = null;
    this.confirmApproveVildVersionDialog.hide();
  }

  public approveVildVersion(): void {
    this.isApprovingVild = true;
    this.approveVildErrorMessages = [];

    if (this.vildVersion) {
      this.vildVersionService.approveVildVersion(this.vildVersion.id).subscribe(
        () => {
          this.vildVersionIsSuccessfullyApproved = true;

          setTimeout(() => {
            this.isApprovingVild = false;
            this.onConfirm.emit(true);
            this.confirmApproveVildVersionDialog.hide();
          }, this.modalTimeout);
        },
        error => {
          this.isApprovingVild = false;

          if (error instanceof CBMError) {
            this.approveVildErrorMessages.push(error);
          } else if (error instanceof Array) {
            this.approveVildErrorMessages = error;
          }
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-vild-approve/dialog-vild-approve.component.ts